import { render, staticRenderFns } from "./JoinSocialView.vue?vue&type=template&id=64efd651&scoped=true&"
import script from "./JoinSocialView.vue?vue&type=script&lang=js&"
export * from "./JoinSocialView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64efd651",
  null
  
)

export default component.exports